// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__row___n42Rz{
    display: flex;
    gap: 1rem;
    justify-content: end;
}`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Account/components/Number/Subaccounts/DeleteLineItem/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,oBAAoB;AACxB","sourcesContent":[".row{\n    display: flex;\n    gap: 1rem;\n    justify-content: end;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `styles__row___n42Rz`
};
export default ___CSS_LOADER_EXPORT___;
